import { Avatar, Row } from "antd";
import { useCallback, useMemo } from "react";
import { useFormatConvTime } from "../../hooks/useFormatConvTime";
import { ISelectedConversation } from "../../../../types/SelectedConversation";

type ConversationProps = {
  item: any;
  conversation: ISelectedConversation | null;
  contractNumber: number;
  readConversation: (
    contractNumber: number,
    selectedConvValues: ISelectedConversation,
  ) => void;
};

export const Conversation = ({
  item,
  conversation,
  contractNumber,
  readConversation,
}: ConversationProps) => {
  const { format } = useFormatConvTime();

  const containerClass: string = useMemo(
    () =>
      `justify-space-between align-center w-100 pa-4 conv clickable-item logo-cursor ${
        conversation?.id === item.id ? "active" : ""
      }`,
    [item, conversation],
  );

  const displayValueClass: string = useMemo(
    () =>
      `ml-4 text display-value elipsis ${
        item.hasUnreadMessages ? "w-500" : ""
      }`,
    [item],
  );

  const onClick = useCallback(
    () =>
      readConversation(contractNumber, {
        id: item.id,
        contractNumber,
        type: item.conversationType,
        name: item.displayName.split(" (")[0],
        propertyAddress: item.propertyAddress,
        isArchived: item.isArchived,
        hasUnreadMessages: item.hasUnreadMessages,
      }),
    [readConversation, item, contractNumber],
  );

  return (
    <Row
      className={containerClass}
      key={item.id}
      id={item.id}
      onClick={onClick}
    >
      <Row className="align-center">
        <Avatar className="avatar">{item.displayName.charAt(0)}</Avatar>
        <span className={displayValueClass} title={item.displayName}>
          {item.displayName}
        </span>
      </Row>
      <Row className="align-center">
        {item.hasUnreadMessages && <span className="has-messages mx-2" />}
        <span className="text-sm title">{format(item.lastUpdatedAt)}</span>
      </Row>
    </Row>
  );
};
